"use client";

import { Layout } from 'antd';
import styles from './Benefits.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';
import { ArrowUpRightIcon, CheckIcon, XIcon } from '@/shared/constants/icon';

const { Content } = Layout;

const negBenefitsData = [
  {
    id: 1,
    title: "neg1",
  },
  {
    id: 2,
    title: "neg2",
  },
  {
    id: 3,
    title: "neg3",
  },
  {
    id: 4,
    title: "neg4",
  },
];

const posBenefitsData = [
  {
    id: 1,
    title: "pos1",
  },
  {
    id: 2,
    title: "pos2",
  },
  {
    id: 3,
    title: "pos3",
  },
  {
    id: 4,
    title: "pos4",
  },
];

const posInfoData = [
  {
    id: 1,
    title: "info.title1",
    value: "info.value1",
  },
  {
    id: 2,
    title: "info.title2",
    value: "info.value2",
  },
  {
    id: 3,
    title: "info.title3",
    value: "info.value3",
  },
  {
    id: 4,
    title: "info.title4",
    value: "info.value4",
  },
];

export const Benefits = () => {
  const t = useTranslations("aiAgent.benefits");

  return (
    <Content className={styles.root}>
      <ScrollReveal>
        <h1>{t("title")}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_cards}>
        <section className={styles.root_cards_item}>
          <h5>{t("negTitle")}</h5>

          <div className={styles.neg_info}>
            <span className={styles.neg_info_title}>«{t("negInfo")}»</span>
            <span className={styles.info_subtitle}>
              <ArrowUpRightIcon />
              {t("minInfo")}
            </span>
          </div>

          <section className={styles.info_list}>
            {negBenefitsData.map(item =>
              <h6 key={item.id} className={styles.info_list_item}>
                <XIcon color="var(--color-red)" />
                {t(item.title)}
              </h6>
            )}
          </section>
        </section>

        <section className={styles.root_cards_item}>
          <h5>{t("posTitle")}</h5>

          <div className={styles.pos_info}>
            {posInfoData.map(item =>
              <div key={item.id} className={styles.pos_info_title}>
                <span>{t(item.title)}</span>
                <span>{t(item.value)}</span>
              </div>
            )}
            <span className={styles.info_subtitle}>
              <ArrowUpRightIcon />
              {t("maxInfo")}
            </span>
          </div>

          <section className={styles.info_list}>
            {posBenefitsData.map(item =>
              <h6 key={item.id} className={styles.info_list_item}>
                <CheckIcon color="var(--color-green)" />
                {t(item.title)}
              </h6>
            )}
          </section>
        </section>
      </ScrollReveal>
    </Content>
  );
};
